import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { StaffuseLocalStorage } from "./StaffuseLocalStorage";
const StaffAuthContext = createContext();

export const StaffAuthProvider = ({ children }) => {
  const [user, setUser] = StaffuseLocalStorage("user", null);
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (data, token) => {
    setUser(data);

    localStorage.setItem("_id", data[0]._id);
    localStorage.setItem("Username", data[0].Username);
    localStorage.setItem("Team", data[0].Team);
    localStorage.setItem("Level", data[0].Level);
    localStorage.setItem("Token", token);
    navigate("/Staff");
  };

  // call this function to sign out logged in user
  const logout = () => {
    setUser(null);
    localStorage.clear();
    navigate("/Staff", { replace: true });
  };

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
    }),
    [user]
  );
  return (
    <StaffAuthContext.Provider value={value}>
      {children}
    </StaffAuthContext.Provider>
  );
};

export const StaffuseAuth = () => {
  return useContext(StaffAuthContext);
};
